module.exports = __webpack_public_path__ + "img/card.59b725b0.png";